import request from '../request'
import { objectToQueryString } from '../../components/Dashboard/DataEntry/helpers/objectToQueryString'

export const getSurveys = (skip = 0, limit = 50, filter, active = true) =>
  request
    .get(`/data-entry/surveys?skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(filter)}`)
    .then((res) => res)

export const getSurvey = (surveyId = '', includeResults = false) =>
  request
    .get(`/data-entry/surveys/${surveyId}${includeResults ? '?includeResults=true' : ''}`)
    .then((res) => res)

export const getSurveyAboutById = (surveyId, recordId) =>
  request.get(`/data-entry/surveys/${surveyId}/about/${recordId}`).then((res) => res)

export const getMySurveys = (skip = 0, limit = 50, filter, active = true) =>
  request
    .get(`/data-entry/my-surveys?skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(filter)}`)
    .then((res) => res)

export const getMySurvey = (surveyId = '') =>
  request.get(`/data-entry/my-surveys/fill-a-survey/${surveyId}`).then((res) => res)

export const getUsersForSurvey = (skip = 0, limit = 50, filter = {}, surveyId = '') =>
  request
    .get(`/data-entry/surveys/users/${surveyId}?skip=${skip}&limit=${limit}&${objectToQueryString(filter)}`)
    .then((res) => res)

export const getClassesForSurvey = (skip = 0, limit = 50, filter = {}, surveyId = '') =>
  request
    .get(`/data-entry/surveys/classes/${surveyId}?skip=${skip}&limit=${limit}&${objectToQueryString(filter)}`)
    .then((res) => res)

export const updateSurveyRecord = (recordId = '', data) =>
  request.put(`/data-entry/surveys/${recordId}`, data).then((res) => res)

export const fillASurvey = (data) =>
  request.put(`/data-entry/my-surveys/fill-a-survey`, data).then((res) => res)

export const deleteSurvey = (surveyId = '') =>
  request.delete(`/data-entry/surveys/${surveyId}`).then((res) => res)

export const createSurvey = (data) => request.post(`/data-entry/surveys`, data).then((res) => res)

export const cloneSurvey = (surveyId = '', data) =>
  request.post(`/data-entry/surveys/${surveyId}/clone`, data).then((res) => res)

export const getMySurveysAboutMe = (skip = 0, limit = 50, filter, active = true) =>
  request
    .get(
      `/data-entry/my-surveys/about-me?skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(
        filter
      )}`
    )
    .then((res) => res)
export const getMySurveysAboutMyClasses = (skip = 0, limit = 50, filter, active = true) =>
  request
    .get(
      `/data-entry/my-surveys/about-my-classes?skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(
        filter
      )}`
    )
    .then((res) => res)

export const getSurveyByIdAbout = (surveyId, recordId) =>
  request.get(`/data-entry/my-surveys/fill-a-survey/${surveyId}/about/${recordId}`).then((res) => res)

export const fillASurveyAbout = (surveyId, recordId, data) =>
  request.post(`/data-entry/my-surveys/fill-a-survey/${surveyId}/about/${recordId}`, data).then((res) => res)

export const getSurveyNameTaken = (name = '', surveyId = '') =>
  request
    .get(`/data-entry/surveys/check-name/${name}${surveyId ? `?surveyId=${surveyId}` : ''}`)
    .then((res) => res)
